import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useSteps } from '../../hooks/use-steps.js';
import { ConfiguratorStep } from './ConfiguratorStep.js';

const ConfiguratorStepContainer = (props)=>{
    const { currentStep  } = useSteps();
    const { view: CurrentStepComponent  } = currentStep;
    return /*#__PURE__*/ React.createElement(ConfiguratorStep, swcHelpers.extends({}, props), /*#__PURE__*/ React.createElement(CurrentStepComponent, null));
};

export { ConfiguratorStepContainer };
//# sourceMappingURL=ConfiguratorStepContainer.js.map
